<template>
  <div id="eestec">
    <div class="eestec-content">
      <div class="logo">
        <a :href="link">
          <img :src="logo" alt="EESTEC Bucharest" />
        </a>
      </div>
        <p class= "text">{{$t('home.eestec.about')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/images/EESTEC.png"),
      link: "http://eestec.ro"
    };
  }
};
</script>

<style scoped lang="scss">
#eestec {
  // min-width: 100%;
  background-image: url("../../assets/images/poza_grup_min.jpg");
  background-size: cover;
  background-position: center;
}

.eestec-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

}

.logo {
  padding: 10vh 0 10vh 0;
  width: 100%;
}

img {
  width: 20%;
  display: block;
  margin: auto;
}

.text {
  width: 70%;
  text-align: center;
  font-size: calc(20px + (80 - 20) * ((100vw - 1024px) / (3840 - 1024)));
  font-family: "Acumin Variable Concept";
  margin-bottom: 10vh;
}

p,
h1 {
  color: #fff !important;
}
h1 {
  text-align: center;
  font-size: 3.5em;
  font-weight: 500;
}

@media screen and (max-width: 1024px) {
  img {
    width: 40%;
  }
  .text {
    font-size: 4vw;
    flex-basis: 90%;
    text-align: center;
  }
}
</style>